import React from 'react';
import {View, ViewStyle} from 'react-native';

import {styles} from './Spacer.style';

interface SpacerProps {
  direction: 'vertical' | 'horizontal';
  size: number;
}

export const Spacer: React.FC<SpacerProps> = ({
  direction = 'vertical',
  size = 0,
}) => {
  const spacerStyle: ViewStyle =
    direction === 'horizontal'
      ? {height: 1, width: size}
      : {width: 1, height: size};

  return <View style={[styles.base, spacerStyle]} />;
};

export default Spacer;
